import React, { useEffect } from 'react'
import { HeaderDrawer } from '../../../../../../Components/CustomUi/headerGaveta'
import { BodyDrawer } from './styled'
import Tabs from '../../../../../../Components/Tabs'
import { faDroplet, faFlask, faSeedling } from '@fortawesome/free-solid-svg-icons'
import { Render } from '../../../../../../Components/CustomUi/render'
import { FormDados } from './components/formularioDados'
import { Composicao } from './components/composicao'

interface PropsForm {
  update: number
  nome: string
  setNome: React.Dispatch<React.SetStateAction<string>>
  formulacao: string
  setFormulacao: React.Dispatch<React.SetStateAction<string>>
  setFormulacao_id: React.Dispatch<React.SetStateAction<number>>
  fabricante: string
  setFabricante: React.Dispatch<React.SetStateAction<string>>
  setFabricante_id: React.Dispatch<React.SetStateAction<number>>
  tecnologia: string
  setTecnologia: React.Dispatch<React.SetStateAction<string>>
  setTecnologia_id: React.Dispatch<React.SetStateAction<number>>

  volume_por_dose: string
  setVolume_por_dose: React.Dispatch<React.SetStateAction<string>>
  observacao: string
  setObservacao: React.Dispatch<React.SetStateAction<string>>
  tab_selecionar_atual: string
  setTab_selecionar_atual: React.Dispatch<React.SetStateAction<string>>
  origem_selecionada: string
  setOrigem_selecionada: React.Dispatch<React.SetStateAction<string>>
  setOrigem_selecionada_id: React.Dispatch<React.SetStateAction<number>>
  tipo_biologico_selecionadas: { descr: string; id: number; key?: number }[]
  setTipo_biologico_selecionadas: React.Dispatch<
    React.SetStateAction<{ descr: string; id: number; key?: number }[]>
  >
  tipo_aplicacao_selecionadas: { descr: string; id: number; key?: number }[]
  setTipo_aplicacao_selecionadas: React.Dispatch<
    React.SetStateAction<{ descr: string; id: number; key?: number }[]>
  >
  microrganismo_selecionado: string
  setMicrorganismo_selecionado: React.Dispatch<React.SetStateAction<string>>
  setMicrorganismo_selecionado_id: React.Dispatch<React.SetStateAction<number>>
  valor: string
  setValor: React.Dispatch<React.SetStateAction<string>>
  expoente: string
  setExpoente: React.Dispatch<React.SetStateAction<string>>
  porcentagem: string
  setPorcentagem: React.Dispatch<React.SetStateAction<string>>
  tipo_porcentagem: string
  setTipo_porcentagem: React.Dispatch<React.SetStateAction<string>>
  setTipo_porcentagem_id: React.Dispatch<React.SetStateAction<number>>
  concentracao: string
  setConcentracao: React.Dispatch<React.SetStateAction<string>>
  cepa: string
  setCepa: React.Dispatch<React.SetStateAction<string>>
  densidade: string
  setDensidade: React.Dispatch<React.SetStateAction<string>>
  confirmar_exclusao: boolean
  setConfirmar_exclusao: React.Dispatch<React.SetStateAction<boolean>>
  id_item_atual: number
  setId_item_atual: React.Dispatch<React.SetStateAction<number>>
  setNome_item_atual: React.Dispatch<React.SetStateAction<string>>
  editar_concentracao: number
  fake_loading: boolean
  data_biológicos: any[]
  data_formulação: any[]
  data_aplicação: any[]
  data_tecnologia: any[]
  data_microrganismos: any[]
  data_fabricante: any[]
  composicao_adicionada: any[]
  adicionarComposicao: Function
  editarComposicao: Function
  salvarComposicao: Function
  mudarConcentracao: Function
  remover_microrganismos: Function
  loadingComposicao: boolean
}

export const FormularioBiotecnologias: React.FC<PropsForm> = ({
  update,
  nome,
  setNome,

  volume_por_dose,
  setVolume_por_dose,
  formulacao,
  setFormulacao,
  setFormulacao_id,
  fabricante,
  setFabricante,
  setFabricante_id,
  tecnologia,
  setTecnologia,
  setTecnologia_id,
  observacao,
  setObservacao,
  tab_selecionar_atual,
  setTab_selecionar_atual,
  origem_selecionada,
  setOrigem_selecionada,
  setOrigem_selecionada_id,
  tipo_biologico_selecionadas,
  setTipo_biologico_selecionadas,
  tipo_aplicacao_selecionadas,
  setTipo_aplicacao_selecionadas,
  microrganismo_selecionado,
  setMicrorganismo_selecionado,
  setMicrorganismo_selecionado_id,
  concentracao,
  setConcentracao,
  valor,
  setValor,
  expoente,
  setExpoente,
  porcentagem,
  setPorcentagem,
  tipo_porcentagem,
  setTipo_porcentagem,
  setTipo_porcentagem_id,
  cepa,
  setCepa,
  confirmar_exclusao,
  setConfirmar_exclusao,
  id_item_atual,
  setId_item_atual,
  fake_loading,
  setNome_item_atual,
  editar_concentracao,
  data_aplicação,
  data_biológicos,
  data_formulação,
  data_tecnologia,
  data_microrganismos,
  data_fabricante,
  composicao_adicionada,
  adicionarComposicao,
  editarComposicao,
  salvarComposicao,
  mudarConcentracao,
  remover_microrganismos,
  loadingComposicao,
  densidade,
  setDensidade,
}) => {
  useEffect(() => {
    if (['Sólido', 'Turfosa', 'Liofilizada'].includes(formulacao)) {
      setTipo_porcentagem('m/m')
      setTipo_porcentagem_id(1)
    } else {
      setTipo_porcentagem('')
      setTipo_porcentagem_id(null)
    }
  }, [formulacao])

  return (
    <div>
      <HeaderDrawer>
        <div>{update > 0 ? 'Atualizar biológicos' : 'Cadastrar biológicos'}</div>
      </HeaderDrawer>
      <BodyDrawer>
        <Tabs
          tabs={[
            { descricao: 'Dados do biológico', icone: faSeedling },
            {
              descricao: 'Composição',
              icone: faFlask,
              disabled: tipo_biologico_selecionadas.some(
                (item) => item.descr === 'Complexo de Microrganismos'
              ),
            },
          ]}
          selecionado={tab_selecionar_atual}
          trackWidth={328}
          onChange={setTab_selecionar_atual}
        />
        <Render condition={tab_selecionar_atual === 'Dados do biológico'}>
          <FormDados
            nome={nome}
            setNome={setNome}
            origem_selecionada={origem_selecionada}
            setOrigem_selecionada={setOrigem_selecionada}
            setOrigem_selecionada_id={setOrigem_selecionada_id}
            fabricante={fabricante}
            setFabricante={setFabricante}
            setFabricante_id={setFabricante_id}
            tipo_biologico_selecionadas={tipo_biologico_selecionadas}
            setTipo_biologico_selecionadas={setTipo_biologico_selecionadas}
            formulacao={formulacao}
            setFormulacao={setFormulacao}
            setFormulacao_id={setFormulacao_id}
            tipo_aplicacao_selecionadas={tipo_aplicacao_selecionadas}
            setTipo_aplicacao_selecionadas={setTipo_aplicacao_selecionadas}
            tecnologia={tecnologia}
            setTecnologia={setTecnologia}
            setTecnologia_id={setTecnologia_id}
            observacao={observacao}
            setObservacao={setObservacao}

            volume_por_dose={volume_por_dose}
            setVolume_por_dose={setVolume_por_dose}
            data_biológicos={data_biológicos}
            data_formulação={data_formulação}
            data_aplicação={data_aplicação}
            data_tecnologia={data_tecnologia}
            data_fabricante={data_fabricante}
          />
        </Render>
        <Render condition={tab_selecionar_atual === 'Composição'}>
          <Composicao
            microrganismo_selecionado={microrganismo_selecionado}
            setMicrorganismo_selecionado={setMicrorganismo_selecionado}
            setMicrorganismo_selecionado_id={setMicrorganismo_selecionado_id}
            concentracao={concentracao}
            setConcentracao={setConcentracao}
            cepa={cepa}
            setCepa={setCepa}
            data_microrganismos={data_microrganismos}
            composicao_adicionada={composicao_adicionada}
            adicionarComposicao={adicionarComposicao}
            editarComposicao={editarComposicao}
            salvarComposicao={salvarComposicao}
            mudarConcentracao={mudarConcentracao}
            confirmar_exclusao={confirmar_exclusao}
            setConfirmar_exclusao={setConfirmar_exclusao}
            id_item_atual={id_item_atual}
            setId_item_atual={setId_item_atual}
            setNome_item_atual={setNome_item_atual}
            fake_loading={fake_loading}
            remover_microrganismos={remover_microrganismos}
            valor={valor}
            setValor={setValor}
            expoente={expoente}
            setExpoente={setExpoente}
            porcentagem={porcentagem}
            setPorcentagem={setPorcentagem}
            tipo_porcentagem={tipo_porcentagem}
            setTipo_porcentagem={setTipo_porcentagem}
            setTipo_porcentagem_id={setTipo_porcentagem_id}
            editar_concentracao={editar_concentracao}
            loadingComposicao={loadingComposicao}
            densidade={densidade}
            setDensidade={setDensidade}
            formulacao={formulacao}
          />
        </Render>
      </BodyDrawer>
    </div>
  )
}
